<template>
  <div class="page" v-wechat-title="$route.meta.title='我的评论'">

    <div class="comments-list border-box account-list-sr">
      <div class="comments-list-data box border-box" v-for="(item,index) in root" :key="index">
        <p class="block head-img-box">
          <img class="img" :src="item.rzimg?item.rzimg:item.headimg" />
        </p>

        <div class="flex comments-list-info  border-box">
          <div class="comments-person-box box ">
            <div class="block comments-person">
              <p class="comments-person-name">{{item.rzname?item.rzname:item.name}}</p>
              <p class="star-level">
                <template v-for="(star,index) in [2,4,6,8,10]">
                  <img v-if="item.score>=star" src="../../assets/icon_com.png"/>
                  <img v-else src="../../assets/start_nor.png" />
                </template>
              </p>
            </div>
            <p class="block flex comments-person-time">{{item.addtime}}</p>
            <p class="praise" >
              <span>{{item.totalZan}}</span>
              <img src="../../assets/icon_zan.png" />
            </p>
          </div>

          <div class="comments-detail border-box">
            <p class="comments-detail-top">{{item.content}}</p>
          </div>

          <div class="comments-detail-replay" v-if="item.replys.length>0">
            <p class="comments-replay-text" v-for="(item,index) in item.replys" :key="index">
              <span>{{item.bagname}}</span> 回复
              <span>{{item.name}}</span> ：{{item.content}}
            </p>
          </div>

          <router-link class="comments-img box border-box" :to="{path:'/video-play',query: {id: item.bagid,shopid:item.shopid, TimeStamp: TimeStamp}}">
            <img v-lazy="aimg" v-for="(aimg,ind) in item.allimg" :key="ind" />
          </router-link>
          <router-link class="comments-video box border-box" :to="{path:'/video-play',query: {id: item.bagid,shopid:item.shopid, TimeStamp: TimeStamp}}">
            <p class="block comments-video-img">
              <img class="img bor50" v-lazy="item.guideheadimg2?item.guideheadimg2:item.bheadimg" />
            </p>
            <div class="block flex comments-video-info">
              <p class="comments-video-group hide">{{item.bname}}</p>
              <p class="comments-video-name hide">{{item.guidename2?item.guidename2:item.uname}}{{item.description?('/'+item.description):''}}</p>
              <p class="comments-video-price hide">￥{{item.price}}</p>
            </div>
          </router-link>
          <img class="icon-delete" @click="delMyComt(index)"  src="../../assets/icon_delete.png" />
        </div>
      </div>

      <p class="load-tip" ref="loadtip">{{loadText}}</p>
    </div>


  </div>

</template>

<script>

  import {getMyComment, deleteComment} from "@/service/getData";
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        userInfo: {}, //用户信息
        page: 1,
        rows: 10,
        loadText: "数据加载中",

        root:'',//评论列表
        total:'',//评论总条数

        TimeStamp: new Date().getTime(),  //获取当前时间
      }
    },
    computed: {

    },
    created(){

      this.$loading.show('数据加载中');

      this.id = this.$route.query.id;
      this.userInfo = getStore("userInfo");

      this.initData(this.page);

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      //获取语音+景区+推荐信息
      async initData(page){
        let res = await getMyComment({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: page,
          rows: this.rows,
        });
        console.log(res.data);

        if (res.errcode === "00000"){
          this.$loading.hide();

          this.total = res.data.total
          let root = res.data.root
          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      //用户删除评论
      delMyComt(index){
        let self = this;

        this.$confirm({
          title: '提示',
          content: '确认要删除此条评论吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.delete(index)
          }
        }).catch(function(res){
          if(res == 'success') {
            self.delete(index)
          }
        })

      },

      async delete(index){
        let res = await deleteComment({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          commentid:this.root[index].id
        });
        console.log(res)
        if(res.errcode == "00000"){
          this.root.splice(index,1);
          this.$toast("删除成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      }

    },
    components: {
      wxConfirm
    },

  }

</script>

<style scoped>

  .list-tab .flex text{position:absolute;top:0;left:0;width:100%;height:100%;text-align:center;z-index:2;}
  .list-tab .flex text:after{content:'';position:absolute;top:.30rem;bottom:.30rem;right:0;width:.01rem;background:#e4e4e4;}
  .list-tab .flex.curr text{color:#faaf39;}

  .comments-list{width:100%;padding:.36rem 0 .16rem .36rem; margin-bottom: 0; }
  .comments-list-data{padding-top:.13rem;}
  .head-img-box{width:.60rem;height:auto;border-radius:50%;}
  .head-img-box image{width:.60rem;height:.60rem;border-radius:50%;}
  .comments-list-info{position:relative;padding-bottom:.55rem;margin-left:.14rem;border-bottom:1px dashed #bcbcbc;}
  .comments-person-box{width:100%;}
  .comments-person{position:relative;width:1.45rem;height:.60rem;}
  .comments-person-name{width:1.45rem;font-size:.22rem;color:#a9a0cc; padding-right: 0;}
  .star-level{display:block;width:2rem;height:.20rem;margin-top:.15rem;}
  .star-level image{width:.17rem;height:.17rem;margin-right:.07rem;float:left;}
  .comments-person-time{height:.20rem;line-height:.20rem;margin-top:.10rem;font-size:.20rem;color:#a6a6a6;}
  .praise{position:absolute;top:0;right:.24rem;height:.29rem;line-height:.29rem;}
  .praise text{font-size:.20rem;color:#faaf39;}
  .praise image{width:.27rem;height:.25rem;margin-top:.02rem;margin-left:.10rem;}
  .comments-detail{width:100%;margin-top:.30rem;padding-right:.20rem;}
  .comments-detail .comments-detail-top{line-height:.32rem;font-size:.26rem;color:#333;word-wrap : break-word;}
  .comments-detail-replay{width:100%;padding:.13rem 0;margin-top:.16rem;background:#fafafa;}
  .comments-replay-text{line-height:.32rem;padding:.15rem 0;margin-top:.10rem;font-size:.24rem;color:#373737;word-wrap : break-word;}
  .comments-detail-replay .comments-replay-text:first-child{margin-top:0;}
  .comments-replay-text text{color:#978ebc;}
  .comments-video{width:74.8%;height:1.30rem;margin-top:.13rem;padding:.15rem .24rem;background:#f6f6f6;}
  .comments-video-img{width:1.10rem;height:1.00rem;border-right:1px solid #e5e5e5;}
  .comments-video-img image{width:1.00rem;height:1.00rem;}
  .comments-video-info{margin-left:.15rem;}
  .comments-video-group{font-size:.24rem;color:#333;}
  .comments-video-name{margin-top:.03rem;font-size:.20rem;color:#333;}
  .comments-video-price{margin-top:.03rem;font-size:.20rem;color:#faaf39;}
  .icon-delete{position:absolute;right:.13rem;bottom:.14rem;width:.26rem;height:.26rem;}
  .comments-list-data-receive .comments-detail-replay {width:60%;padding:.13rem 0; margin-left:10%; margin-top:.10rem;border-top:1px solid #bcbcbc;border-bottom:none;}
  .comments-img{ display: block; margin-top:.16rem;}
  .comments-img image{ float: left; width:1.00rem;height:1.00rem;margin-right:.20rem;margin-bottom:.10rem;}

</style>



// WEBPACK FOOTER //
// src/page/my-comment/my-comment.vue